import './Main.css'

import { useAppContext } from '@/context/app'
import { Spinner } from '@/components/spinner'
import { Machine } from '@/services/model/machine'
import { useNavigate } from 'react-router-dom'


export const Result = ({ machine }: {
  machine: Machine
}) => {
  const { translates } = useAppContext()
  const navigate = useNavigate()

  if (!translates) {
    return <Spinner />
  }

  return <div>
    <h2>{translates.for('machine.checklist.wizard.result.title')}</h2>
    {translates.for('machine.checklist.wizard.result.description')}
    <div className='btns'>
      <a className='btn btn-next main-btn' onClick={() => navigate(`/communal/machine/${machine.id}`)}>
        {translates.for('machine.checklist.wizard.result.approve')}
      </a>
    </div>
  </div>
}